export const responseBooleanSerializer = async (response: Response) => {
  const data = await response.text();

  if (data === "true") {
    return true;
  }
  if (data === "false") {
    return false;
  }
  throw Error("Unexpected response");
};
